var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.937 17a.933.933 0 0 1-.688-.304.922.922 0 0 1-.245-.713l.228-2.514L10.79 2.912l3.3 3.3L3.533 16.768l-2.513.228A.886.886 0 0 1 .937 17Zm13.81-11.448-3.298-3.3L13.428.275a.932.932 0 0 1 1.32 0l1.978 1.979a.933.933 0 0 1 0 1.32L14.75 5.551l-.001.001Z",
    fill: "#333"
  })));
};
export default SvgEdit;